<template>
  <div class="bono-comision">
    <md-dialog :md-active.sync="correctGrati" class="z-index-1000">
      <!-- <md-progress-bar class="md-accent" md-mode="query" v-if="this.loading_files"></md-progress-bar> -->
      <md-dialog-title>Correción de Gratificación</md-dialog-title>
      <md-field>
        <label>Monto</label>
        <md-input v-model.number="newGrati"></md-input>
      </md-field>
      <md-dialog-actions>
        <md-button class="md-primary" @click="correctGrati = false">Cancelar</md-button>
        <md-button class="md-primary md-raised" @click="corregirGrati"
          >Corregir</md-button
        >
      </md-dialog-actions>
    </md-dialog>
    <div class="bono-comision__new">
      <md-content>
        <h3 class="history-title">Histórico de Pagos</h3>
      </md-content>
      <div class="history__filters">
        <div></div>
        <md-field>
          <md-icon>search</md-icon>
          <label>Buscar</label>
          <md-input v-model="search"></md-input>
        </md-field>
        <md-field>
          <label for="date-history">Fecha</label>
          <v-date-picker
            v-model="range"
            class="datepick"
            mode="range"
            :formats="formats"
            popover-visibility="focus"
            :max-date="new Date()"
          >
            <!-- OJO -->
            <md-input
              slot-scope="{ inputValue }"
              style="text-align: left !important"
              :value="inputValue | formatDate"
              readonly
              name="date-history"
              id="date-history"
            ></md-input>
          </v-date-picker>
        </md-field>
        <div></div>
        <div></div>
        <md-field>
          <label for="concepto-history">Concepto</label>
          <md-select
            v-model="selectedConcept"
            name="concepto-history"
            id="concepto-history"
            md-dense
          >
            <md-optgroup label="Conceptos">
              <md-option
                :value="concept.code"
                v-for="concept in $store.getters.myConcepts"
                :key="concept.id"
                >{{ concept.name }}</md-option
              >
            </md-optgroup>
            <md-optgroup label="Otros">
              <md-option
                value="tardiness"
                v-if="this.$store.state.enterprise.dataBusiness.enableTardinessDiscount"
                >Tardanza</md-option
              >
              <md-option value="advance-payment">Adelantos</md-option>
              <md-option value="loans">Prestamos</md-option>
              <md-option value="eps-deduction">EPS</md-option>
              <md-option value="food-voucher">Vale de Alimentos</md-option>
              <md-option value="deduction">Otros Descuentos</md-option>
            </md-optgroup>
          </md-select>
        </md-field>
        <md-button class="md-raised md-primary" @click="searchHistory">
          Buscar
        </md-button>
        <div></div>
      </div>
    </div>

    <div class="bono-comision__separator"></div>

    <div class="bono-comision__history">
      <div class="bono-comision__detail" v-for="(item, index) in historic" :key="index">
        <!-- <i class="icon-close" @click="deleteThis(item)"></i> -->
        <div class="bono-comision__detail-date">
          {{ item.date | formatDateHistory }}
        </div>
        <div class="bono-comision__detail-description">
          {{ item.description }}
          <md-chip>{{ conceptType[item.type] }}</md-chip>
        </div>
        <div class="bono-comision__detail-monto">
          <p>
            {{ deductionList.includes(item.type) ? "-" : "" }}{{ item.value | currency }}
          </p>
          <md-button
            class="md-primary md-raised md-dense button--historic"
            v-if="item.description === 'Pago por concepto de gratificación'"
            @click="gratiCorrection(item)"
            >Corregir</md-button
          >
        </div>
      </div>
    </div>
    <div class="history__footer" v-if="pages > 1">
      <paginate
        v-model="actualPage"
        :pageCount="pages"
        :prev-text="'p'"
        :next-text="'q'"
        :containerClass="'pagination'"
        :page-class="'page-item'"
        :clickHandler="changePages"
      ></paginate>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Paginate from "vuejs-paginate";
export default {
  name: "Employee-Historic",
  components: {
    Paginate,
  },
  data() {
    return {
      description: "",
      date: null,
      value: null,
      type: "",
      formats: {
        input: "DD MMM YYYY",
      },
      conceptSelected: null,
      concept: null,
      conceptCode: null,
      conceptItem: null,
      personalConcepts: [],
      historic: [],
      page: 1,
      pages: 1,
      correctGrati: false,
      newGrati: 0,
      gratiId: null,
      conceptType: {
        "5ta": "Quinta",
        deduction: "Descuento",
        "prev-cts": "CTS provisión",
        cts: "CTS",
        "prev-vacations": "Vacaciones provisión",
        "prev-gratifications": "Gratificación provisión",
        "monthly-remuneration": "Sueldo mensual",
        none: "Ingreso",
        gratifications: "Gratificación",
        "food-voucher": "Vale de alimentos (Desc)",
        loans: "Prestamos (Desc)",
        "advance-payment": "Adelanto (Desc)",
        "eps-deduction": "EPS (Desc)",
        tardiness: "Tardanza (Desc)",
      },
      selectedConcept: null,
      search: null,
      range: {
        start: null,
        end: new Date(),
      },
      deductionList: [
        "tardiness",
        "advance-payment",
        "loans",
        "eps-deduction",
        "deduction",
        "food-voucher",
      ],
      //bonos y comisiones
      // bonos: []
    };
  },
  created() {
    this.$store.dispatch("getCommissionList", this.$route.params.id);
    this.getDetailBusiness(this.$store.state.business.businessId).then((r) => {
      if (r.status == 200) {
        console.log("conceptos propios obtenidos");
        this.$store
          .dispatch("getEmployeeConceptsHistoric", {
            id: this.$route.params.id,
            params: {
              page: 1,
            },
          })
          .then((res) => {
            if (res.status == 200) {
              console.log(res.data);
              // this.personalConcepts = JSON.parse(
              //   JSON.stringify(this.$store.state.business.personalConcepts)
              // );res.data
              this.page = res.data.currentPage;
              this.pages = res.data.totalPages;
              this.historic = res.data.results;
            }
          });
      }
    });
  },
  // activated() {
  //   this.page = 1;
  //   this.$store.dispatch("getCommissionList", this.$route.params.id);
  //   this.$store
  //     .dispatch("getEmployeeConceptsHistoric", {
  //       id: this.$route.params.id,
  //       page: this.page,
  //     })
  //     .then((res) => {
  //       if (res.status == 200) {
  //         console.log(res.data);
  //         // this.personalConcepts = JSON.parse(
  //         //   JSON.stringify(this.$store.state.business.personalConcepts)
  //         // );
  //         if (res.status == 200) {
  //           console.log(res.data);
  //           // this.personalConcepts = JSON.parse(
  //           //   JSON.stringify(this.$store.state.business.personalConcepts)
  //           // );res.data
  //           this.page = res.data.currentPage;
  //           this.pages = res.data.totalPages;
  //           this.historic = res.data.results;
  //           this.$nextTick(() => {
  //             this.$forceUpdate();
  //           });
  //         }
  //       }
  //     });
  // },
  computed: {
    ...mapGetters({
      myConcepts: "myConcepts",
    }),
    actualPage: {
      set(val) {
        console.log(val);

        this.page = val;
      },
      get() {
        return this.page;
      },
    },
    historicList() {
      return this.historic.filter((hs) => hs.value !== 0);
    },
    // myConcepts(){
    //   if(!this.$store.state.business.personalConcepts) return []
    //   return this.$store.state.business.personalConcepts.map(item => {
    //     return {
    //       name: item.concept.name,
    //       id: item.concept.id
    //     }
    //   })
    // },
    bonos() {
      return this.personalConcepts;
    },

    minDate() {
      return new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    },
  },
  filters: {
    formatDate(value) {
      let splitStr = value.split(" ");
      for (let i = 0; i < splitStr.length; i++) {
        if (i == 1)
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() +
            splitStr[i].substring(1, splitStr[i].length);
      }
      return splitStr.join(" ");
    },

    formatDateHistory(value) {
      let valueDate = new Date(value);
      let month = "";
      switch (valueDate.getMonth()) {
        case 0:
          month = "Ene";
          break;
        case 1:
          month = "Feb";
          break;
        case 2:
          month = "Mar";
          break;
        case 3:
          month = "Abr";
          break;
        case 4:
          month = "May";
          break;
        case 5:
          month = "Jun";
          break;
        case 6:
          month = "Jul";
          break;
        case 7:
          month = "Ago";
          break;
        case 8:
          month = "Sept";
          break;
        case 9:
          month = "Oct";
          break;
        case 10:
          month = "Nov";
          break;
        case 11:
          month = "Dic";
          break;
      }
      return valueDate.getDate() + " " + month + " " + valueDate.getFullYear();
    },

    toSoles(value) {
      return `S/. ${Number(value).toFixed(2)}`;
    },
  },

  methods: {
    ...mapActions({
      getDetailBusiness: "getDetailBusiness",
    }),
    searchHistory() {
      console.log("buscar");
      this.$store
        .dispatch("getEmployeeConceptsHistoric", {
          id: this.$route.params.id,
          params: {
            page: 1,
            search: this.search,
            startAt: this.range.start ? this.range.start : undefined,
            endAt: this.range.start ? this.range.end : undefined,
            conceptCode: this.deductionList.includes(this.selectedConcept)
              ? undefined
              : this.selectedConcept,
            type: this.deductionList.includes(this.selectedConcept)
              ? this.selectedConcept
              : undefined,
          },
        })
        .then((res) => {
          this.page = res.data.currentPage;
          this.pages = res.data.totalPages;
          this.historic = res.data.results;
        });
    },
    changePages(page) {
      console.log(page);
      this.loading = true;
      this.$store
        .dispatch("getEmployeeConceptsHistoric", {
          id: this.$route.params.id,
          params: {
            search: this.search,
            startAt: this.range.start ? this.range.start : undefined,
            endAt: this.range.start ? this.range.end : undefined,
            conceptCode: this.deductionList.includes(this.selectedConcept)
              ? undefined
              : this.selectedConcept,
            type: this.deductionList.includes(this.selectedConcept)
              ? this.selectedConcept
              : undefined,
            page: this.page,
          },
        })
        .then((res) => {
          if (res.status == 200) {
            this.historic = res.data.results;
            this.page = res.data.currentPage;
            this.pages = res.data.totalPages;
          }
        });
    },
    corregirGrati() {
      console.log("Corregir grati");
      this.$store
        .dispatch("updateVariant", {
          id: this.gratiId,
          body: { value: this.newGrati },
        })
        .then((res) => {
          if (res.status === 200) {
            this.newGrati = 0;
            this.gratiId = null;
            this.correctGrati = false;
            this.$store
              .dispatch("getEmployeeConceptsHistoric", {
                id: this.$route.params.id,
                page: 1,
              })
              .then((res) => {
                if (res.status === 200) {
                  this.page = res.data.currentPage;
                  this.pages = res.data.totalPages;
                  this.historic = res.data.results;
                  this.$nextTick(() => {
                    this.$forceUpdate();
                  });
                }
              });
          }
        });
    },
    gratiCorrection(item) {
      this.gratiId = item.id;
      this.newGrati = item.value;
      this.correctGrati = true;
    },
  },
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #c63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img + $img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//7-TRUMPS
.md-field,
.md-button {
  width: 18rem;
  @include mq($sm) {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}

.bono-comision {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
  padding-bottom: 3rem;
  &__new {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: center;
    width: 100%;
    @include mq($sm) {
      flex-direction: row;
      justify-content: center;
    }
  }
  &__separator {
    height: 1px;
    width: 100%;
    background-color: rgba($b-blue, 0.3);
    margin: 2rem 0;
  }

  &__history {
    border-radius: 9px;
    border: 1px solid rgba($b-blue, 0.3);
    border-left: 3px solid $b-orange;
    overflow: hidden;
  }

  &__detail {
    height: 6rem;
    border: 1px solid rgba($b-blue, 0.2);
    width: 24rem;
    display: flex;
    padding-left: 1rem;
    position: relative;
    @include mq($sm) {
      width: 36rem;
    }

    .icon-close {
      position: absolute;
      top: 0.3rem;
      right: 0.3rem;
      color: $b-orange;
      font-size: 1.2rem;
      @include mq($md) {
        cursor: pointer;
      }
    }
    &-date {
      width: 2.5rem;
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    &-description {
      margin-left: 2rem;
      display: flex;
      flex-flow: column nowrap;
      align-items: flex-start;
      justify-content: center;
      width: 9rem;
      color: rgba($b-blue, 0.75);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      @include mq($sm) {
        width: 21rem;
      }
    }
    &-monto {
      margin-left: 2rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      font-weight: 500;
    }
  }
}
.history__footer {
  margin: 1rem auto;
}
.button--historic {
  width: 88px !important;
}
.z-index-1000 {
  z-index: 1000;
}
.history-title {
  text-align: center;
}
.history__filters {
  padding: 1.5rem;
  width: 100%;
  display: grid;
  gap: 2rem;
  grid-template-columns: 1fr 280px 280px 1fr;
  grid-template-rows: 1fr 1fr;
}
</style>
